import axios from 'axios'
import API_URL from '@/router/api'
import * as types from './mutation-types'

export const findMany = (ctx, form) => {
    return new Promise((resolve, reject) => {

        axios.get(API_URL.resultMessage.findMany, {params: form})
            .then(res => {
                ctx.commit(types.SET_RESULT_MESSAGE, res.data.data.data);
                delete res.data.data.data;
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const findManyMessage = (ctx, form) => {
    return new Promise((resolve, reject) => {

        axios.get(API_URL.resultMessage.findMany, {params: form})
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const create = (ctx, form) => {
    return new Promise((resolve, reject) => {

        axios.post(API_URL.resultMessage.create, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const update = (ctx, { id, form }) => {
    return new Promise((resolve, reject) => {

    axios.put(API_URL.resultMessage.update.replace(/__id__/, id.$oid), form)
        .then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}


export const remove = (ctx, { id }) => {
    return new Promise((resolve, reject) => {

    axios.delete(API_URL.resultMessage.delete.replace(/__id__/, id.$oid))
        .then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const removeMany = (ctx, {ids}) => {
    return new Promise((resolve, reject) => {

    axios.delete(API_URL.resultMessage.deleteMany.replace(/__id__/, `ids[]=${ids.join('&ids[]=')}`), {params: {ids: ids}})
        .then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}
